import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import PropTypes from "prop-types";
import React, { Component } from "react";
import "whatwg-fetch";
import config from "../config";

const scoreStyle = { color: "blue" };

class ContestRankingView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      results: [],
    };
  }

  componentDidMount() {
    return fetch(
      config.backend_url + "contests/" + this.props.contest_id + "/ranking"
    ).then((response) => {
      response.json().then((json) => {
        this.setState({ results: json, loading: true });
      });
    });
  }

  render() {
    const num_problems = this.state.results.num_problems;
    var problems = [];
    for (let i = 1; i <= num_problems; i++) {
      problems.push(<TableCell key={i}>問題{i}</TableCell>);
    }
    var users_results = {};
    const ranking = this.state.results.ranking;
    for (var r in ranking) {
      var user_results = [];
      for (let i = 1; i <= num_problems; i++) {
        const details = ranking[r].details;
        var push_flag = false;
        for (var j in details) {
          if (i !== details[j].idx) continue;
          user_results.push(
            <TableCell key={j + ":" + i}>
              {details[j].point != -1 ? details[j].point+ " (" + details[j].time + ")"  : "?"} 
            </TableCell>
          );
          push_flag = true;
        }
        if (!push_flag) {
          user_results.push(<TableCell key={0 + ":" + i}></TableCell>);
        }
      }
      users_results[ranking[r].name] = user_results;
    }
    if (this.state.loading) {
      return (
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>順位</TableCell>
                <TableCell>ユーザー</TableCell>
                <TableCell>得点</TableCell>
                {problems}
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.results.ranking.map((row) => (
                <TableRow key={row.id + ":" + row.name}>
                  <TableCell>{row.rank}</TableCell>
                  <TableCell>
                      <div className="icon_and_name">
                          <center>
                              <a href={"https://" + window.location.hostname + "/users/" + row.name}><img src={row.image_url} align="middle" width="50" height="50"/></a>
                              <p>
                                  <a
                                      href={"https://" + window.location.hostname + "/users/" + row.name}
                                      style={{ "textDecoration": "none", color: "black" }}
                                  >{row.name}
                                  </a>
                              </p>
                          </center>
                      </div>
                  </TableCell>
                  <TableCell style={scoreStyle}>{row.point}</TableCell>
                  {users_results[row.name]}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      );
    } else {
      return (
        <div className="App-header">
          <p>Loading...</p>
        </div>
      );
    }
  }
}

ContestRankingView.propTypes = {
  contest_id: PropTypes.string.isRequired,
};

export default ContestRankingView;
